var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFloppyWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.5 21V14.75H8V21M19.25 21H4.25C2.86929 21 1.75 19.8807 1.75 18.5V3.5C1.75 2.11929 2.86929 1 4.25 1H14.4645C15.1275 1 15.7634 1.26339 16.2323 1.73224L21.0177 6.51776C21.4866 6.98661 21.75 7.62249 21.75 8.28554V18.5C21.75 19.8807 20.6307 21 19.25 21Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloppyWhite);
export default __webpack_public_path__ + "static/media/floppy-white.e53f0f0d2e3ef5f5fe1b652695e00a95.svg";
export { ForwardRef as ReactComponent };